<script>
    import {acronym} from "../../lib/lib";

    export let service = null;
    export let notActive = false;
    export let lg = false;

    let nameColor = '';
    let nameAcronym = '';

    $: if (service.ws_service) {
        nameColor = service.ws_service.color;
        nameAcronym = acronym(service.ws_service.name);
    } else {
        nameColor = '';
        nameAcronym = '';
    }
</script>
{#if service}
<span class="colored-name" class:not-active={ notActive }>
    <span class="color" style="background: #{nameColor};">{ acronym(nameAcronym) }</span>
    <span class=name class:lg={lg}>{ service.name }</span>
</span>
{/if}

<style>
    .colored-name {
        position: relative;
        display: flex;
        align-items: center;
        width: max-content;
    }

    .colored-name:after {
        content: " ";
        display: block;
        clear: both;
    }

    .colored-name .color {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
        font-size: 0.5rem;
        color: #fff;
        border-radius: 50%;
        margin-right: 4px;
    }

    .colored-name .name {
        display: block;
        line-height: 1;
        padding-left: 20px;
    }

    .colored-name .name.lg {
        font-size: 16px;
    }
</style>